export default __webpack_public_path__ + "static/media/Deceiver's Armbands of Ushering Twilight.ecbf67a8.jpg";